import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6812da78")

_pushScopeId("data-v-6812da78")
const _hoisted_1 = { class: "card mb-5 mb-xl-10 system-settings" }
const _hoisted_2 = { class: "card-body p-9" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "pb-10 pb-lg-15 pt-10 text-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "settings-main-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-warehouse" })
], -1)
const _hoisted_7 = { class: "fw-bolder text-center" }
const _hoisted_8 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_9 = { class: "fv-row mb-8" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-4" }
const _hoisted_12 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_13 = { class: "d-block fw-bold text-start" }
const _hoisted_14 = { class: "settings-heading fw-bolder d-block fs-4 mb-2" }
const _hoisted_15 = { class: "fw-bold fs-6 settings-content" }
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-list-alt" })
], -1)
const _hoisted_19 = { class: "d-block fw-bold text-start" }
const _hoisted_20 = { class: "settings-heading fw-bolder d-block fs-4 mb-2" }
const _hoisted_21 = { class: "fw-bold fs-6 settings-content" }
const _hoisted_22 = { class: "fv-row mb-8" }
const _hoisted_23 = { class: "fw-bolder mb-4" }
const _hoisted_24 = { class: "d-flex flex-wrap gap-8 mb-4 fs-6" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "text-gray-400 me-2" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "text-gray-400 me-2" }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "text-gray-400 me-2" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "fs-6 fw-bold text-gray-400 mb-2" }
const _hoisted_33 = { class: "bg-light rounded p-5 fs-7 mb-0 wms-sync-output" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('message.WMS')), 1),
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('message.WMS_SMART_INTEGRATION')), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _withModifiers(_ctx.syncWmsData, ["prevent"]),
                  class: { 'pe-none': !_ctx.wmsManagesProducts },
                  "aria-disabled": !_ctx.wmsManagesProducts
                }, {
                  default: _withId(() => [
                    _createVNode("label", {
                      class: ["btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center", { 'opacity-50': _ctx.busy || !_ctx.wmsManagesProducts, disabled: !_ctx.wmsManagesProducts }]
                    }, [
                      _createVNode("span", _hoisted_12, [
                        _createVNode("i", {
                          class: ["fas fa-sync-alt", { 'fa-spin': _ctx.busy }]
                        }, null, 2)
                      ]),
                      _createVNode("span", _hoisted_13, [
                        _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('message.WMS_SYNC_DATA')), 1),
                        _createVNode("span", _hoisted_15, _toDisplayString(_ctx.wmsManagesProducts ? _ctx.$t('message.WMS_CLICK_TO_SYNC') : _ctx.$t('message.WMS_SYNC_DISABLED_WMS_OFF')), 1)
                      ])
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["onClick", "class", "aria-disabled"])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode(_component_router_link, { to: { name: 'wms-logs' } }, {
                  default: _withId(() => [
                    _createVNode("label", _hoisted_17, [
                      _hoisted_18,
                      _createVNode("span", _hoisted_19, [
                        _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('message.WMS_LOGS')), 1),
                        _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('message.WMS_LOGS_DESCRIPTION')), 1)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("h3", _hoisted_23, _toDisplayString(_ctx.$t('message.WMS_LAST_SYNC')), 1),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", null, [
                _createVNode("span", {
                  class: `badge badge-light-${_ctx.statusColor}`
                }, _toDisplayString(_ctx.$t(`message.WMS_SYNC_STATUS_${_ctx.status.status.toUpperCase()}`)), 3)
              ]),
              (_ctx.status.requested_by)
                ? (_openBlock(), _createBlock("div", _hoisted_25, [
                    _createVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('message.WMS_SYNC_REQUESTED_BY')), 1),
                    _createTextVNode(_toDisplayString(_ctx.status.requested_by), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.status.started_at)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _createVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('message.WMS_SYNC_STARTED_AT')), 1),
                    _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.status.started_at)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.status.finished_at)
                ? (_openBlock(), _createBlock("div", _hoisted_29, [
                    _createVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('message.WMS_SYNC_FINISHED_AT')), 1),
                    _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.status.finished_at)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.status.output)
              ? (_openBlock(), _createBlock("div", _hoisted_31, [
                  _createVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('message.WMS_SYNC_OUTPUT')), 1),
                  _createVNode("pre", _hoisted_33, _toDisplayString(_ctx.status.output), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
})